module.exports = __webpack_public_path__ + "static/space-illustration-f24000db044bff49f7603ba67875e651.svg";